'use client';

import { FC } from 'react';
import { TrackPageView } from '@tuic/tracking';
import type { PageViewData } from '@tuic/tracking';
export type PageTelemetryBlockData = {
  pageViewData?: Partial<PageViewData>;
};
type Props = {
  data?: PageTelemetryBlockData;
  fallback?: boolean;
};
export const PageTelemetryBlock: FC<Props> = ({
  data,
  fallback
}) => {
  if (fallback) {
    return null;
  }
  if (!data?.pageViewData) {
    return null;
  }
  return <TrackPageView data={data.pageViewData} data-sentry-element="TrackPageView" data-sentry-component="PageTelemetryBlock" data-sentry-source-file="PageTelemetryBlock.tsx" />;
};